import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { FormControlState } from 'ngrx-forms';
import { UserInfoFieldsTranslations } from './user-info-fields.translations';

@Component({
  selector: 'zui-user-info-fields',
  templateUrl: './user-info-fields.component.html',
  styleUrls: [ './user-info-fields.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserInfoFieldsComponent {
  @Input()
  firstName: FormControlState<string>;

  @Input()
  lastName: FormControlState<string>;

  @Input()
  email: FormControlState<string>;

  @Input()
  translations: UserInfoFieldsTranslations;

  @Input()
  mode: 'add' | 'edit' = 'add';

  @Input()
  readOnly = false;

  @Input()
  crossEditing = false;

}
